// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__3DISh","label":"styles_label__3z1Ok","title":"styles_title__2caM8","ticketCount":"styles_ticketCount__1JLbn","minPrice":"styles_minPrice__1hDl2"};